import {Injectable, inject} from '@angular/core';
import {Actions, ofType, createEffect} from '@ngrx/effects';
import {of} from 'rxjs';
import {map, mergeMap, catchError} from 'rxjs/operators';
import {MapService} from '../../../services/map.service';
import * as LandingAction from './landing.actions';
import {MapLayer} from '../../../shared/classes/map-layer';
import {GenServiceType} from '../../../generated/serverModels/GenServiceType';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import {Store} from '@ngrx/store';

@Injectable()
export class LandingEffects {
  private actions$ = inject(Actions);
  private mapService = inject(MapService);
  private store = inject(Store);

  loadMapLayerGroups$ = createEffect(() => this.actions$.pipe(
    ofType(LandingAction.LoadMapLayers),
    mergeMap(() => this.mapService.getMapLayerGroups()
      .pipe(
        map(mapLayerGroups => LandingAction.LoadMapLayersSuccess({mapLayerGroups})),
        catchError((error: Error) => of(LandingAction.LoadMapLayersFailure({error}))),
      ),
    ),
  ));


  public addMapSource$ = createEffect(() => this.actions$.pipe(
    ofType(LandingAction.AddLayerSource),
    map(props => {

      const mapLayer = new MapLayer(props.mapLayer);
      let source: TileLayer<TileWMS> | undefined;
      // This should probably be moved to a separate action.
      if (mapLayer.serviceType === GenServiceType.WMS) {
        source = new TileLayer({
          source: new TileWMS({
            url: mapLayer.serviceUrl,
            params: {'LAYERS': mapLayer.serviceLayer, tiled: true},
          }),
        });
        mapLayer.renderedLayer = source;
      }

      MapService.getMapRef()!.addLayer(source!);
    }),
  ), {dispatch: false});

}
